<template>
  <ModalFormButtonsContainer>
    <template v-if="$slots['aside']" #aside>
      <slot name="aside" />
    </template>
    <UIButton
      v-if="!hideCancel"
      variant="black-clear"
      :disabled="disabled || loading"
      type="button"
      :data-test-id="dataTestIdCancel"
      @click="emit('click:cancel', $event)"
      >{{ cancelText || t('generic.cancel') }}
    </UIButton>

    <UIButton
      :disabled="disabled || disabledSubmit"
      :loading="loading"
      :form="form"
      :type="type"
      :variant="variant"
      depressed
      :data-test-id="dataTestIdSubmit"
      @click="emit('click:submit', $event)"
      >{{ submitText || t('generic.save') }}
    </UIButton>
  </ModalFormButtonsContainer>
</template>

<script lang="ts" setup>
import { useTranslate } from '@manager/composables/use-translate';
import ModalFormButtonsContainer from '@manager/modules/modals/base/ModalFormButtonsContainer.vue';
import type { ITableRowConfirmData } from '@manager/types/action-menu-types';
import UIButton from 'shared/ui/registry/kinnovis/ui-button/UIButton.vue';
import { computed } from 'vue';
import type { TranslateResult } from 'vue-i18n';

const { t } = useTranslate();

interface Props {
  color?: ITableRowConfirmData['color'];
  disabled?: boolean;
  disabledSubmit?: boolean;
  loading?: boolean;
  form?: string;
  cancelText?: string | TranslateResult;
  submitText?: string | TranslateResult;
  type?: 'submit' | 'button';
  noMargin?: boolean;
  dataTestIdCancel?: string;
  dataTestIdSubmit?: string;
  hideCancel?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  color: 'primary',
  form: undefined,
  cancelText: undefined,
  disabled: false,
  loading: false,
  submitText: undefined,
  disabledSubmit: false,
  type: 'submit',
  noMargin: false,
  dataTestIdCancel: 'close-button',
  dataTestIdSubmit: 'submit-button',
  hideCancel: false,
});

const emit = defineEmits<{
  'click:cancel': [Event];
  'click:submit': [Event];
}>();

const variant = computed(() => {
  switch (props.color) {
    case 'error':
      return 'danger';
    case 'warning':
      return 'warning';
    case 'primary':
    default:
      return 'primary';
  }
});
</script>
